import React from 'react';
import magnifyingGlass from 'assets/images/search-modal-magnifying-glass.svg';
import { useIntl } from 'react-intl-next';
import Heading from '@atlaskit/heading';
import { Stack } from '@atlaskit/primitives';
import { Img } from '../common';
import messages from './messages';

export const SearchResultNone = ({ term }: { term: string }) => {
    const { formatMessage } = useIntl();

    return (
        <Stack alignInline="center">
            <Img src={magnifyingGlass} />
            <Heading level="h400">{formatMessage(messages.noSearchResultTitle)}</Heading>
            <p style={{ textAlign: 'center' }}>{formatMessage(messages.noSearchResultText, { term })}</p>
        </Stack>
    );
};
